import type {
  ReferentialModelState,
  ReferentialStateEndpoint,
} from "@/entities/referential/referential-states";

import { useReferentialStates } from "@/entities/referential/referential-states";

export const useReferentialState = (
  endpoint: ReferentialStateEndpoint,
  value: string,
  key: keyof ReferentialModelState = "slug"
) => {
  const { states, ...queryResult } = useReferentialStates(endpoint);
  const state = states.find((state) => state[key] === value);

  return {
    ...queryResult,
    state,
  };
};
